// Auto-generated user-center i18n extras. Do not edit by hand unless necessary.
export default {
  "ucAccount": {
    "personal": {
      "section": {
        "basicInfo": "Basic Info",
        "professionalInfo": "Professional Info"
      },
      "identityType": {
        "mainland": "Mainland",
        "hkmt": "HK/Macao/Taiwan"
      },
      "form": {
        "idCardType": "ID Type",
        "uploadIdCard": "Upload ID Card",
        "uploadCertificate": "Upload Certificate",
        "realName": "Real Name",
        "idCardNo": "ID Number",
        "certificateNo": "Certificate No.",
        "internationalName": "International Name",
        "phone": "Phone",
        "email": "Email",
        "industryType": "Industry",
        "unitName": "Organization",
        "jobPosition": "Position",
        "region": "Region"
      },
      "idCard": {
        "mainland": "Mainland ID Card",
        "hkId": "Hong Kong ID Card",
        "hkMacaoPass": "Mainland Travel Permit for HK/Macao Residents",
        "taiwanPass": "Mainland Travel Permit for Taiwan Residents"
      },
      "upload": {
        "frontAlt": "ID front",
        "backAlt": "ID back",
        "frontLabel": "Upload front side (max 2MB)",
        "backLabel": "Upload back side (max 2MB)"
      },
      "placeholder": {
        "autoRecognize": "Auto-filled after upload",
        "internationalName": "Optional; recommended for international filing",
        "pleaseInput": "Please enter",
        "pleaseSelect": "Please select",
        "regionCascader": "Select province/city/district"
      },
      "btn": {
        "reAuth": "Re-verify",
        "submit": "Submit"
      },
      "rule": {
        "selectIdCardType": "Please select ID type",
        "uploadFront": "Please upload front side",
        "uploadBack": "Please upload back side",
        "inputRealName": "Please enter real name",
        "inputIdCardNo": "Please enter ID number",
        "inputPhone": "Please enter phone number",
        "phoneInvalid": "Please enter a valid phone number",
        "inputEmail": "Please enter email",
        "emailInvalid": "Please enter a valid email",
        "selectRegion": "Please select region",
        "selectIndustry": "Please select industry"
      },
      "validate": {
        "mainlandId": "Please enter a valid mainland ID number (15 or 18 digits)",
        "hkMacaoPass": "Please enter a valid HK/Macao travel permit number",
        "taiwanPass": "Please enter a valid Taiwan travel permit number (8 digits)",
        "hkId": "Please enter a valid Hong Kong ID number"
      },
      "msg": {
        "formIncomplete": "Please complete the form",
        "submitting": "Submitting...",
        "submitSuccess": "Identity verification submitted"
      }
    },
    "enterprise": {
      "section": {
        "basicInfo": "Basic Info"
      },
      "regionType": {
        "mainland": "Mainland",
        "hkmt": "HK/Macao/Taiwan"
      },
      "type": {
        "enterprise": "Enterprise",
        "association": "Social Organization"
      },
      "form": {
        "authType": "Verification Type",
        "businessLicense": "Business License",
        "registrationCert": "Registration Certificate",
        "enterpriseName": "Enterprise Name",
        "orgName": "Organization Name",
        "internationalName": "International Name",
        "creditCode": "Unified Social Credit Code",
        "registrationLicenseNo": "Registration No.",
        "orgCertNo": "Organization Certificate No.",
        "orgType": "Organization Type",
        "industryType": "Industry",
        "region": "Region",
        "contactPerson": "Contact",
        "email": "Email",
        "phone": "Phone",
        "smsCode": "Verification Code"
      },
      "upload": {
        "brc": "Upload BRC (max 2MB)",
        "enterpriseLicense": "Upload business license (max 2MB)",
        "associationCert": "Upload registration certificate (max 2MB)",
        "prefix": "Upload ",
        "suffix": " (max 2MB)",
        "fileEnterpriseLicense": "Business License",
        "fileAssociationCert": "Registration Certificate"
      },
      "placeholder": {
        "pleaseInputPrefix": "Please enter ",
        "internationalName": "Optional; recommended for international filing",
        "selectOrgType": "Select organization type",
        "selectIndustry": "Select industry",
        "selectRegion": "Select region",
        "contactPerson": "Enter contact",
        "email": "Enter email",
        "phone": "Enter phone",
        "smsCode": "Enter code"
      },
      "btn": {
        "getCode": "Get Code",
        "countdown": "Retry in {n}s",
        "reAuth": "Re-verify",
        "submit": "Submit",
        "rejectedResubmit": "Rejected, re-verify"
      },
      "rule": {
        "uploadLicense": "Please upload {label}",
        "inputName": "Please enter {label}",
        "inputCreditCode": "Please enter {label}",
        "creditCodeInvalid": "Please enter a valid {label}",
        "inputContact": "Please enter contact",
        "inputPhone": "Please enter phone",
        "phoneInvalid": "Please enter a valid phone",
        "inputSmsCode": "Please enter verification code",
        "inputEmail": "Please enter email",
        "emailInvalid": "Please enter a valid email",
        "selectRegion": "Please select region",
        "selectIndustry": "Please select industry",
        "selectOrgType": "Please select organization type"
      },
      "msg": {
        "phoneRequired": "Please enter phone first",
        "phoneInvalid": "Please enter a valid phone",
        "codeSent": "Code sent",
        "selectRegionType": "Please select region type",
        "uploadLicense": "Please upload business license",
        "submitting": "Submitting...",
        "submitSuccess": "Enterprise verification submitted",
        "reAuthSuccess": "Re-verification submitted"
      }
    },
    "resetPassword": {
      "title": "Reset Password",
      "form": {
        "contactPhone": "Contact Phone",
        "smsCode": "Verification Code",
        "newPassword": "New Password",
        "confirmPassword": "Confirm Password"
      },
      "placeholder": {
        "loadingPhone": "Loading contact phone...",
        "smsCode": "Enter code",
        "newPassword": "8-20 chars with upper, lower and digits",
        "confirmPassword": "Re-enter new password"
      },
      "btn": {
        "getCode": "Get Code",
        "countdown": "Retry in {n}s",
        "submit": "Submit"
      },
      "rule": {
        "phoneMissing": "Contact phone not found",
        "inputSmsCode": "Please enter code",
        "smsCodeLen": "Code must be 6 digits",
        "inputNewPassword": "Please enter new password",
        "confirmAgain": "Please re-enter password",
        "passwordMismatch": "Passwords do not match"
      },
      "msg": {
        "phoneMissingWarn": "Contact phone not found",
        "phoneMissingError": "Contact phone not found",
        "phoneInvalid": "Please enter a valid phone",
        "codeSent": "Code sent",
        "resetSuccess": "Password reset successfully"
      }
    },
    "memberEdit": {
      "title": "Association Member Info",
      "form": {
        "unitAvatar": "Logo",
        "entName": "Organization Name",
        "nature": "Enterprise Nature",
        "industryType": "Industry",
        "mainProducts": "Main Products",
        "introduce": "Introduction",
        "mainProductsList": "Products"
      },
      "upload": {
        "alt": "Logo",
        "label": "Aspect 16:9, recommended 384×216px, max 10MB"
      },
      "placeholder": {
        "entName": "Enter organization name",
        "nature": "Enter enterprise nature",
        "industryType": "Enter industry",
        "mainProducts": "Enter main products",
        "introduce": "Enter introduction",
        "mainProductItem": "Enter product"
      },
      "btn": {
        "add": "Add",
        "confirm": "Confirm"
      },
      "rule": {
        "uploadAvatar": "Please upload logo",
        "inputEntName": "Please enter organization name",
        "inputNature": "Please enter enterprise nature",
        "inputIndustry": "Please enter industry",
        "inputMainProducts": "Please enter main products",
        "inputIntroduce": "Please enter introduction",
        "minMainProducts": "Add at least one product"
      },
      "msg": {
        "noComma": "Product cannot contain commas",
        "duplicateProduct": "Product already exists",
        "loadFail": "Failed to load info",
        "submitSuccess": "Submitted. Awaiting association review",
        "submitFail": "Update failed"
      },
      "confirm": {
        "message": "Submit changes? Your listing will be unpublished until association approval.",
        "title": "Notice",
        "ok": "Submit",
        "cancel": "Cancel"
      }
    },
    "enterpriseAdmin": {
      "btn": {
        "replaceSuperAdmin": "Replace Super Admin"
      },
      "dialog": {
        "replaceTitle": "Replace Super Admin",
        "confirmReplace": "Confirm"
      },
      "status": {
        "enable": "Enable",
        "disable": "Disable",
        "unknown": "Unknown"
      },
      "confirm": {
        "toggleStatus": "{statusText} admin \"{name}\"?",
        "title": "Notice",
        "ok": "OK",
        "cancel": "Cancel"
      },
      "msg": {
        "inviteSuccess": "Invitation sent",
        "replaceSuccess": "Super admin replaced"
      }
    }
  },
  "ucJoinChannel": {
    "title": "Join Channel",
    "form": {
      "channelCode": "Channel Code"
    },
    "placeholder": {
      "channelCode": "Enter channel code for filing discounts"
    },
    "btn": {
      "join": "Join"
    },
    "fallback": {
      "unnamedChannel": "Unnamed Channel"
    },
    "msg": {
      "selectChannel": "Please select a channel",
      "inputChannelCode": "Please enter channel code",
      "joinSuccess": "Joined successfully"
    }
  },
  "ucOrder": {
    "filter": {
      "all": "All",
      "orderTime": "Order Time"
    },
    "date": {
      "rangeSeparator": "to",
      "startPlaceholder": "Start date",
      "endPlaceholder": "End date"
    },
    "btn": {
      "myInvoice": "My Invoices",
      "detail": "Details"
    },
    "table": {
      "orderNo": "Order No.",
      "orderType": "Order Type",
      "orderAmount": "Amount",
      "payableAmount": "Paid Amount",
      "orderTime": "Order Time",
      "payMethod": "Payment Method",
      "payTime": "Payment Time",
      "payStatus": "Status",
      "operation": "Actions"
    },
    "detail": {
      "title": "Order Details",
      "orderNo": "Order No.",
      "orderType": "Order Type",
      "orderAmount": "Amount",
      "payableAmount": "Paid Amount",
      "payStatus": "Status",
      "payMethod": "Payment Method",
      "orderTime": "Order Time",
      "payTime": "Payment Time",
      "goodsType": "Product Type",
      "goodsName": "Product Name",
      "refundAmount": "Refund Amount",
      "remark": "Remark"
    },
    "payMethod": {
      "zero": "Zero Pay",
      "alipay": "Alipay",
      "wechat": "WeChat Pay"
    },
    "payStatus": {
      "pending": "Pending",
      "success": "Paid",
      "cancelled": "Cancelled",
      "refunded": "Refunded"
    }
  },
  "ucInvoice": {
    "filter": {
      "all": "All",
      "invoiceStatus": "Invoice Status",
      "orderNo": "Order No."
    },
    "placeholder": {
      "statusAll": "All",
      "orderNo": "Enter order no."
    },
    "status": {
      "all": "All",
      "invoiced": "Invoiced",
      "pending": "Pending"
    },
    "btn": {
      "confirmInvoice": "Issue Invoice",
      "confirmInvoiceWithCount": "Issue Invoice ({n})",
      "detail": "Details",
      "invoice": "Invoice"
    },
    "table": {
      "orderNo": "Order No.",
      "orderType": "Order Type",
      "orderTime": "Order Time",
      "productName": "Product",
      "orderAmount": "Amount (CNY)",
      "payAmount": "Paid (CNY)",
      "payTime": "Payment Time",
      "invoiceStatus": "Invoice Status",
      "operation": "Actions"
    },
    "detail": {
      "title": "Order Details",
      "orderNo": "Order No.",
      "orderType": "Order Type",
      "invoiceStatus": "Invoice Status",
      "orderAmount": "Amount (CNY)",
      "payAmount": "Paid (CNY)",
      "productName": "Product",
      "orderTime": "Order Time",
      "payTime": "Payment Time",
      "remark": "Remark"
    },
    "msg": {
      "selectPending": "Please select pending orders"
    },
    "issue": {
      "title": "Issue Invoice",
      "section": {
        "headerInfo": "Invoice Header"
      },
      "btn": {
        "addHeader": "Add Header",
        "setDefault": "Set Default",
        "delete": "Delete",
        "confirmInvoice": "Confirm",
        "confirm": "Confirm"
      },
      "empty": {
        "noHeader": "No invoice header yet. Please add one."
      },
      "badge": {
        "defaultHeader": "Default"
      },
      "label": {
        "titleType": "Type: ",
        "taxNumber": "Tax No.: ",
        "companyAddress": "Address: ",
        "phone": "Phone: ",
        "bankName": "Bank: ",
        "bankAccount": "Account: ",
        "enterpriseTitle": "Enterprise Title",
        "personalTitle": "Personal Title",
        "receiveEmail": "Receive Email",
        "email": "Email"
      },
      "stats": {
        "selectedOrders": "Selected: ",
        "orderUnit": "",
        "orderNo": "Order No.: ",
        "amount": "Amount: ",
        "yuan": "CNY"
      },
      "headerDialog": {
        "addTitle": "Add Invoice Header",
        "editTitle": "Edit Invoice Header"
      },
      "headerForm": {
        "titleType": "Type",
        "taxNumber": "Tax No.",
        "companyAddress": "Address",
        "phone": "Phone",
        "bankName": "Bank",
        "bankAccount": "Account"
      },
      "placeholder": {
        "pleaseInput": "Please enter"
      },
      "rule": {
        "selectTitleType": "Please select type",
        "inputEnterpriseTitle": "Please enter enterprise title",
        "inputPersonalTitle": "Please enter personal title",
        "inputReceiveEmail": "Please enter email",
        "inputEmail": "Please enter email",
        "emailInvalid": "Invalid email",
        "inputTaxNumber": "Please enter tax number",
        "inputCompanyAddress": "Please enter address",
        "inputPhone": "Please enter phone",
        "inputBankName": "Please enter bank",
        "inputBankAccount": "Please enter account"
      },
      "msg": {
        "selectOrAddHeader": "Please select or add an invoice header",
        "selectOrders": "Please select orders",
        "invalidOrderNo": "Invalid order number",
        "invoiceSuccess": "Invoice issued",
        "batchInvoiceSuccess": "Batch invoice issued",
        "invoiceFail": "Failed to issue invoice",
        "setDefaultSuccess": "Set as default",
        "deleteSuccess": "Deleted",
        "loginRequired": "Please log in first",
        "editSuccess": "Updated",
        "addSuccess": "Added"
      },
      "confirm": {
        "deleteHeader": "Delete this invoice header?",
        "title": "Notice",
        "ok": "OK"
      },
      "titleTypeOption": {
        "personal": "Personal",
        "enterprise": "Enterprise"
      }
    },
    "billDetail": {
      "title": "Invoice Details",
      "status": {
        "current": "Current Status",
        "unknown": "Unknown"
      },
      "btn": {
        "previewInvoice": "Preview",
        "preview": "Preview",
        "copyLink": "Copy Link"
      },
      "section": {
        "buyer": "Buyer Info",
        "invoice": "Invoice Info"
      },
      "buyer": {
        "name": "Buyer Name",
        "taxNo": "Tax No.",
        "phone": "Phone",
        "address": "Address",
        "bankName": "Bank",
        "bankAccount": "Account"
      },
      "invoice": {
        "type": "Invoice Type",
        "redBlueFlag": "Red/Blue",
        "drawer": "Issuer",
        "codeNo": "Code/No.",
        "digitNo": "E-invoice No.",
        "digitAccount": "E-account",
        "createDate": "Created",
        "invoiceDate": "Issued",
        "issueMethod": "Method",
        "issueMethodValue": "API"
      },
      "flag": {
        "blue": "Blue",
        "red": "Red"
      },
      "typeCode": {
        "85": "E-paper (Special VAT)",
        "86": "E-paper (General)",
        "87": "E-paper (Vehicle Sales)",
        "88": "E-paper (Used Vehicle)",
        "01": "E-invoice (Special VAT)",
        "02": "E-invoice (General)",
        "004": "Special VAT Invoice",
        "005": "Vehicle Sales Invoice",
        "006": "Used Vehicle Invoice",
        "007": "General VAT Invoice",
        "025": "General VAT Invoice (Roll)",
        "026": "E-General VAT Invoice",
        "028": "E-Special VAT Invoice"
      },
      "pdf": {
        "name": "E-invoice PDF",
        "hint": "Preview online or copy the download link"
      },
      "empty": {
        "noBill": "No invoice data"
      },
      "msg": {
        "noPdfUrl": "No PDF URL",
        "copied": "Copied",
        "copyFail": "Copy failed",
        "invalidOrderNo": "Invalid order number",
        "noBillWarn": "No invoice data",
        "queryFail": "Failed to query invoice"
      }
    }
  },
  "ucMessage": {
    "actions": {
      "markAllRead": "Mark All Read"
    },
    "loading": "Loading...",
    "status": {
      "unread": "Unread",
      "read": "Read",
      "starred": "Starred"
    },
    "confirm": {
      "markAllRead": "Mark all unread \"{messageTypeName}\" messages as read?",
      "title": "Confirm",
      "ok": "OK",
      "cancel": "Cancel"
    },
    "fallback": {
      "systemMessage": "System"
    },
    "toast": {
      "markSuccess": "Marked successfully"
    },
    "tabs": {
      "system": "System",
      "business": "Business",
      "activity": "Activity"
    }
  },
  "ucApproval": {
    "tabs": {
      "pending": "Pending Auth",
      "myInitiated": "My Requests"
    },
    "columns": {
      "applicant": "Requester",
      "approver": "Approver",
      "businessType": "Type",
      "status": "Status",
      "createTime": "Requested At",
      "operateTime": "Handled At",
      "actions": "Actions"
    },
    "actions": {
      "authorize": "Authorize",
      "detail": "Details"
    },
    "mobile": {
      "applicant": "Requester: ",
      "approver": "Approver: ",
      "createTime": "Requested: ",
      "operateTime": "Handled: "
    },
    "status": {
      "unknown": "Unknown",
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "toast": {
      "loadMyInitiatedFail": "Failed to load requests",
      "approved": "Authorized"
    },
    "detail": {
      "title": "Authorization Details",
      "ok": "OK",
      "applicant": "Requester: ",
      "approver": "Approver: ",
      "businessType": "Type: ",
      "status": "Status: ",
      "createTime": "Requested: ",
      "operateTime": "Handled: "
    },
    "confirm": {
      "message": "Authorize this request?",
      "title": "Confirm",
      "pass": "Approve",
      "reject": "Reject",
      "applicant": "Requester: ",
      "businessType": "Type: "
    }
  },
  "ucConsultation": {
    "tabs": {
      "awaitingAnswer": "Awaiting Reply",
      "inConsultation": "In Progress",
      "completed": "Completed"
    },
    "search": {
      "placeholder": "Search"
    },
    "columns": {
      "index": "No.",
      "title": "Title",
      "type": "Type",
      "industry": "Industry",
      "area": "Region",
      "submitTime": "Submitted",
      "actions": "Actions"
    },
    "actions": {
      "detail": "Details"
    },
    "toast": {
      "loadDetailFail": "Failed to load consultation"
    },
    "detail": {
      "back": "Back",
      "labels": {
        "title": "Title: ",
        "type": "Type: ",
        "industry": "Industry: ",
        "area": "Region: ",
        "content": "Content: ",
        "attachment": "Attachment: ",
        "expert": "Expert: "
      },
      "attachmentFallback": "Attachment",
      "preview": "Preview",
      "download": "Download",
      "alt": {
        "customer": "Customer",
        "replier": "Replier"
      },
      "chatEmpty": "No chat history",
      "placeholder": {
        "reply": "Enter reply",
        "followUp": "Enter follow-up question"
      },
      "finish": "End Consultation",
      "replyBtn": {
        "sendReply": "Send Reply",
        "append": "Follow Up"
      },
      "endedTip": "Consultation ended",
      "toast": {
        "needContent": "Please enter content",
        "abnormal": "Consultation data error",
        "sendSuccess": "Sent",
        "sendFail": "Send failed",
        "finished": "Consultation ended",
        "operateFail": "Operation failed"
      },
      "confirm": {
        "finish": "End this consultation? You will not be able to send messages afterward.",
        "tip": "Notice"
      }
    }
  },
  "ucActivity": {
    "title": "My Activities",
    "search": {
      "placeholder": "Search"
    },
    "date": {
      "rangeSeparator": "to",
      "startPlaceholder": "Start month",
      "endPlaceholder": "End month",
      "format": "MMM YYYY"
    },
    "actions": {
      "query": "Search",
      "reset": "Reset",
      "viewDetail": "View Details"
    },
    "card": {
      "activityId": "Activity ID:"
    },
    "empty": "No activities yet",
    "loading": "Loading..."
  },
  "ucCollection": {
    "tabs": {
      "ip": "Saved IP",
      "supplyChain": "Saved Supply Chain"
    },
    "actions": {
      "goTradingCenter": "Go to Licensing Center"
    },
    "empty": {
      "supplyChain": "No saved supply chains",
      "ip": "No saved IP"
    }
  }
}
